import './index.scss';
import React from 'react';
import { Iconfont, Modal, SnackBar } from '@umu/umu-design';
import { IconShow } from './iconShow';
import { lang } from '@umu/ukit-lang';
import cloneDeep from 'lodash/cloneDeep';
import { onTransformData } from './dataFlow';
import { IAppNavigationItemIcon, IIconItemInfo } from '../../interface/interface';
import { IIconInfo, IMAGE_TYPE } from '../../interface';
import { getNavIcon } from '../../utils';
import { IconSelect } from '../iconSelect';
import { If } from 'common/src/components';
import { DEFAULT_CUSTOM_ICON_COLOR, DEFAULT_ICON_COLOR } from '../../dataFlow';

interface IProps {
    navName?: string;
    isForceSvgToImg?: boolean; // 强制显示图片
    isHideActiveIcon?: boolean;
    isHideNormalIcon?: boolean;
    isShowIconList?: boolean;
    isShowColor?: boolean;
    resetInfo?: IIconItemInfo;
    iconList: IIconItemInfo[];
    value: IAppNavigationItemIcon;
    onChange: (value: IAppNavigationItemIcon) => void;
}
const { confirm } = Modal;
const onEditorIconDialog = (
    data: {
        info: IIconInfo;
        isForceSvgToImg?: boolean;
        navName: string;
        isShowIconList: boolean;
        isShowColor: boolean;
        iconList: IIconItemInfo[];
        resetInfo?: IIconItemInfo;
        isOnlyShowActive: boolean;
    },
    onChange: (value: IAppNavigationItemIcon) => void,
) => {
    const {
        info,
        navName,
        iconList = [],
        isForceSvgToImg = false,
        resetInfo,
        isOnlyShowActive,
        isShowIconList,
        isShowColor,
    } = data;
    let preInfo = cloneDeep(info);
    confirm({
        centered: true,
        width: 640,
        title: lang('更改导航图标${navName}').replace('${navName}', navName ? ` - ${navName}` : ''),
        okType: 'primary-blue',
        cancelText: lang('取消'),
        okText: lang('确认'),
        zIndex: 4000,
        content: (
            <IconSelect
                resetInfo={resetInfo}
                defaultInfo={preInfo}
                isForceSvgToImg={isForceSvgToImg}
                isShowIconList={isShowIconList}
                isShowColor={isShowColor}
                isOnlyShowActive={isOnlyShowActive}
                list={iconList}
                colorConfig={{
                    restColor: isOnlyShowActive ? DEFAULT_CUSTOM_ICON_COLOR : DEFAULT_ICON_COLOR,
                }}
                onChange={(val) => {
                    preInfo = val;
                }}
            />
        ),
        onOk: () => {
            const { iconType, normalIcon, activeIcon } = preInfo;
            const isEmptyImg = isOnlyShowActive ? !activeIcon : !normalIcon || !activeIcon;
            const isImgListHasEmpty = Number(iconType) === IMAGE_TYPE.CUSTOM && isEmptyImg;
            if (isImgListHasEmpty) {
                SnackBar.show({
                    message: !normalIcon ? lang('请上传默认图标') : lang('请上传选中图标'),
                });
                return Promise.reject();
            }
            onChange(onTransformData(preInfo));
            return Promise.resolve();
        },
    });
};

function IconListShow(props: IProps) {
    const {
        value = {},
        navName = '',
        isForceSvgToImg = false,
        isHideActiveIcon = false,
        isHideNormalIcon = false,
        isShowIconList = false,
        isShowColor = false,
        resetInfo,
        iconList,
        onChange,
    } = props;
    const info = getNavIcon(value, { isHideNormalIcon, isForceSvgToImg });
    const onEditorClick = () => {
        onEditorIconDialog(
            {
                info,
                resetInfo,
                isForceSvgToImg,
                iconList,
                isShowIconList,
                isShowColor,
                navName,
                isOnlyShowActive: isHideNormalIcon,
            },
            onChange,
        );
    };
    return (
        <div className="nav-config-icon-preview-info">
            <If condition={!isHideNormalIcon}>
                <IconShow info={info} isActive={false} className="col-icon-split" />
            </If>
            <If condition={!isHideActiveIcon}>
                <IconShow info={info} isActive={true} className="col-icon-split" />
            </If>
            <Iconfont className="icon-nav icon-nav-editor" type="Import" onClick={onEditorClick} />
        </div>
    );
}

export { IconShow, IconListShow };
